/**
 * Dashboard APIクライアント
 * Phase 1: リアルタイム運営状況データ取得
 */

import { apiV3 } from '@/utils/api';
import type {
  KpiData,
  CheckinCheckoutData,
  WeeklyComparisonDataType,
  TodayScheduleData,
  AttendanceTrendDataType,
} from '../types/enhanced';
import type { KpiDetailData, KpiType } from '../types/kpiDetail';

export const dashboardApi = {
  /**
   * KPI統計データ取得
   */
  getKpi: async (): Promise<KpiData> => {
    const response = await apiV3.get<{ data: KpiData }>('/dashboard/kpi');
    return response.data.data;
  },

  /**
   * 入退室データ取得
   */
  getCheckinCheckout: async (): Promise<CheckinCheckoutData> => {
    const response = await apiV3.get<{ data: CheckinCheckoutData }>(
      '/dashboard/checkin-checkout'
    );
    return response.data.data;
  },

  /**
   * 週比較データ取得
   */
  getWeeklyComparison: async (): Promise<WeeklyComparisonDataType> => {
    const response = await apiV3.get<{ data: WeeklyComparisonDataType }>(
      '/dashboard/weekly-comparison'
    );
    return response.data.data;
  },

  /**
   * 本日のスケジュールデータ取得
   */
  getTodaySchedule: async (): Promise<TodayScheduleData> => {
    const response = await apiV3.get<{ data: TodayScheduleData }>(
      '/dashboard/today-schedule'
    );
    return response.data.data;
  },

  /**
   * 出席率トレンドデータ取得
   */
  getAttendanceTrend: async (): Promise<AttendanceTrendDataType> => {
    const response = await apiV3.get<{ data: AttendanceTrendDataType }>(
      '/dashboard/attendance-trend'
    );
    return response.data.data;
  },

  /**
   * KPI詳細データ取得
   */
  getKpiDetail: async (kpiType: KpiType): Promise<KpiDetailData> => {
    const response = await apiV3.get<{ data: KpiDetailData }>(`/dashboard/kpi/${kpiType}`);
    return response.data.data;
  },
};
